import { jsx, jsxs } from "react/jsx-runtime";
import { memo } from "react";
import {
  Path,
  Rect,
  Svg
} from "react-native-svg";
import { themed } from "../themed";
const Icon = (props) => {
  const { color = "black", size = 24, ...otherProps } = props;
  return /* @__PURE__ */ jsxs(
    Svg,
    {
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: `${color}`,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      ...otherProps,
      children: [
        /* @__PURE__ */ jsx(
          Path,
          {
            d: "M22 8.35V20a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V8.35A2 2 0 0 1 3.26 6.5l8-3.2a2 2 0 0 1 1.48 0l8 3.2A2 2 0 0 1 22 8.35Z",
            stroke: `${color}`
          }
        ),
        /* @__PURE__ */ jsx(Path, { d: "M6 18h12", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M6 14h12", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Rect, { width: "12", height: "12", x: "6", y: "10", stroke: `${color}` })
      ]
    }
  );
};
Icon.displayName = "Warehouse";
const Warehouse = memo(themed(Icon));
export {
  Warehouse
};
//# sourceMappingURL=warehouse.js.map
